/**
 * Default fields for file object query
 */
export const FILES = ['id', 'title'];
